import { render, staticRenderFns } from "./FifthPage.vue?vue&type=template&id=cfe5a952&scoped=true&"
import script from "./FifthPage.vue?vue&type=script&lang=js&"
export * from "./FifthPage.vue?vue&type=script&lang=js&"
import style0 from "./FifthPage.vue?vue&type=style&index=0&id=cfe5a952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe5a952",
  null
  
)

export default component.exports